import type React from "react";
import { useMemo } from "react";
import {
    Container,
    SegmentContainer,
    SegmentTitle,
    Listing,
} from "app/pages/digital-suite/home-page/components/CustomAssets/SegmentsTooltipContent/styledComponents";

interface ISegmentsTooltipContentProps {
    list: string[];
    title: string;
}

export const SegmentsTooltipContent: React.FC<ISegmentsTooltipContentProps> = ({ list, title }) => {
    const segments = useMemo<Array<{ title: string; list: string[] }>>(
        () => [
            {
                title,
                list,
            },
        ],
        [list, title],
    );

    return (
        <Container>
            {segments.map((segment, index) => (
                <SegmentContainer
                    key={segment.title}
                    index={index}
                >
                    <SegmentTitle>{segment.title}</SegmentTitle>
                    {segment.list.map((item) => (
                        <Listing key={item}>{item}</Listing>
                    ))}
                </SegmentContainer>
            ))}
        </Container>
    );
};
